// extracted by mini-css-extract-plugin
export var typingIndicator = "_ot-0";